import { type IMapGeoObject } from '@cian/frontend-newbuilding-map-component';

import * as ReactDOMServer from 'react-dom/server';

import { MapPin } from 'shared/components/MapPin';
import { type ICoordinates } from 'shared/types/residentials';

interface IGetGeoObjectOptions {
  markAsPlus: boolean;
  name: string;
  coordinates?: ICoordinates | null;
  id?: string | null;
}

export const getGeoObject = ({ name, coordinates, id, markAsPlus }: IGetGeoObjectOptions): IMapGeoObject | null => {
  const lat = coordinates?.lat;
  const lng = coordinates?.lng;

  if (!lat || !lng || !id) {
    return null;
  }

  return {
    name,
    options: {
      coordinates: { lat, lng },
      height: 32,
      html: ReactDOMServer.renderToStaticMarkup(<MapPin theme={markAsPlus ? 'plus' : 'default'} />),
      id,
      width: 32,
      zIndex: markAsPlus ? 100 : undefined,
    },
    type: 'Point',
  };
};
